import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShuttlerockLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	"aria-labelledby": "ShuttlerockLogoTitle",
	role: "presentation",
	viewBox: "0 0 725 110",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", {
			id: "ShuttlerockLogoTitle",
			children: "Shuttlerock"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M180.077 74.2881C180.077 83.0721 185.694 89.4082 194.046 89.4082C202.83 89.408 209.021 82.496 209.021 73.2803V33.5361H229.037V106.112H209.021V96.0322C204.989 102.944 196.926 107.264 186.846 107.264C170.574 107.264 159.918 95.312 159.918 78.752V33.5361H180.077V74.2881Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M406.644 32.3838C432.275 32.3838 442.355 51.3917 442.355 67.8076C442.355 70.5436 442.211 72.7041 442.067 74.2881H389.939C391.523 84.5121 397.86 90.8477 408.084 90.8477C416.148 90.8476 421.476 87.68 423.06 81.4883H442.644C439.763 97.184 425.94 107.264 408.084 107.264C383.316 107.264 370.788 87.9677 370.788 69.6797C370.788 51.3918 382.02 32.3838 406.644 32.3838ZM406.644 47.0723C398.004 47.0723 392.388 52.112 390.372 61.4717H422.483C421.763 53.4078 416.291 47.0723 406.644 47.0723Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M531.446 32.3838C553.766 32.3838 569.751 48.2242 569.751 69.8242C569.751 91.4241 553.766 107.264 531.446 107.264C509.127 107.263 493.143 91.424 493.143 69.8242C493.143 48.2243 509.126 32.384 531.446 32.3838ZM531.446 49.5195C520.646 49.5197 513.303 57.7284 513.303 69.8242C513.303 81.776 520.647 89.9842 531.446 89.9844C542.246 89.9844 549.591 81.7761 549.591 69.8242C549.591 57.7282 542.246 49.5195 531.446 49.5195Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M609.904 32.3838C628.912 32.3839 644.032 43.904 645.328 60.752H625.168C624.016 54.2721 617.824 49.5197 610.48 49.5195C599.536 49.5195 593.344 58.0162 593.344 69.8242C593.344 81.6321 599.681 89.9844 610.769 89.9844C618.112 89.9842 623.872 85.5199 625.456 79.04H645.76C643.744 95.168 628.624 107.264 609.904 107.264C587.296 107.264 572.464 90.9921 572.464 69.8242C572.464 48.6562 587.296 32.3838 609.904 32.3838Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M101.901 43.6162C105.933 36.5602 113.997 32.3838 124.077 32.3838C140.349 32.3838 151.005 44.1925 151.005 60.8965V106.112H130.846V65.3604C130.846 56.5764 125.229 50.2402 116.877 50.2402C108.093 50.2404 101.901 57.0083 101.901 66.3682V106.112H81.8848V2H101.901V43.6162Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M267.038 33.5361H298.618V12.0801H318.777V33.5361H338.218V50.2402H318.777V78.8965C318.777 85.9521 322.378 89.2636 328.857 89.2637H338.218V106.112H326.266C309.562 106.112 298.618 96.6077 298.618 79.7598V50.2402H267.038V78.8965C267.038 85.9522 270.638 89.2637 277.118 89.2637H286.478V106.112H274.525C257.822 106.112 246.878 96.6076 246.878 79.7598V50.2402H233.054V33.5361H246.878V12.0801H267.038V33.5361Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M364.174 106.112H344.158V2H364.174V106.112Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M469.513 45.6318C473.401 36.56 478.873 33.5362 487.801 33.5361H495.865V50.2402H483.913C473.977 50.2402 469.513 58.448 469.513 70.832V106.112H449.497V33.5361H469.513V45.6318Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M672.033 58.1602L697.233 33.5361H722.577L693.634 62.0479L724.882 106.112H700.689L680.098 75.4404L672.033 83.3604V106.112H651.873V2H672.033V58.1602Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M68 23.7363H36.2803C27.7845 23.7363 22.3118 26.7679 22.3115 33.1035C22.3115 53.9835 75.3037 35.1195 75.3037 75.4395C75.3036 94.3034 60.1837 106.111 37.7197 106.111H0V87.3916H37.7197C47.2236 87.3916 53.5595 83.3594 53.5596 75.7275C53.5596 55.7115 1 72.7035 1 33.1035C1.00028 15.9678 15.8325 5.16016 36.2803 5.16016H68V23.7363Z"
		})
	]
});
export default SvgShuttlerockLogo;
